import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { createDashboardActions } from './actions';
import { DashboardActions, DashboardState } from './types';

export const useDashboardStore = create<DashboardState & DashboardActions>()(
    immer((set, get, store) => ({
        dashboards: [],
        loading: false,
        selectedDashboard: null,
        loadingDashboard: false,
        error: undefined,
        ...createDashboardActions(set, get, store),
    })),
);
